
import { z } from "zod";

export const TaskAttemptVersionValues = ["v1", "v2", "v3", "v4", "v5", "v6", "v7", "v8", "v9"] as const;
export const TaskAttemptVersionSchema = /* @__PURE__ */ z.enum(TaskAttemptVersionValues);
export const TaskAttemptVersion: (typeof TaskAttemptVersionSchema)["enum"] = { "v1": "v1", "v2": "v2", "v3": "v3", "v4": "v4", "v5": "v5", "v6": "v6", "v7": "v7", "v8": "v8", "v9": "v9" };
export type TaskAttemptVersion = (typeof TaskAttemptVersionValues)[number];
